import { render, staticRenderFns } from "./compLogTribeInto.vue?vue&type=template&id=038367e7&scoped=true&"
import script from "./compLogTribeInto.vue?vue&type=script&lang=js&"
export * from "./compLogTribeInto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038367e7",
  null
  
)

export default component.exports